export default __webpack_public_path__ + "static/media/OG.8235f8f5.svg";